import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user';
import { LoginService } from 'src/app/managers/login.service';
import { CoreResponseMessage } from 'src/app/contracts/responseMessage/coreResponseMessage'
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { AlertDialogComponent } from 'src/app/common/components/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-base',
  template: '' //no html template because this will be used as a base class
})
export class BaseComponent implements OnInit, OnDestroy {
  @Input() parentComponent: string;
  @Input() dataSource: any;
  params: Params;
  dataSourceCallback: () => void;
  private _paramsSubscription: Subscription;
  protected _successMsgDuration: number;
  protected _failMsgDuration: number;

  constructor(protected route: ActivatedRoute, protected loginManager: LoginService, protected clientConfig: ClientConfigService,
              protected dialog: MatDialog) {
    this._successMsgDuration = clientConfig.Configuration.successMsgPopupDuration;
    this._failMsgDuration = clientConfig.Configuration.failMsgPopupDuration;
  }

  ngOnInit() {    
    this._paramsSubscription = this.route.params.subscribe(parameters => {
      this.params = parameters;
    });
  }

  ngOnDestroy() {
    if (!this.undefinedOrNull(this._paramsSubscription))
      this._paramsSubscription.unsubscribe();
  }

  getLoggedinUser(): User {
    return this.loginManager.getLoggedinUser();
  }

  handleCoreResponseMessageError(responseMsg: CoreResponseMessage) {
    console.log(responseMsg);
  }

  isUserLogged(): boolean {
    return this.getLoggedinUser().Email !== '';
  }

  isUserAdmin(): boolean {
    if (this.isUserLogged()) {
      return this.getLoggedinUser().IsAdmin;
    }
    else
      return false;
  }
  
  openAlertDialog(title: string, alertText: string, widthInCss: string, heightInCss: string, mainAction: string = 'noAction'): any {
    return this.dialog.open(AlertDialogComponent, {
      width: widthInCss,
      height: heightInCss,
      data: {
        title: title,
        mainAction: mainAction,
        alertStr: alertText
      }
    });
  }

  undefinedOrNull(value: any): boolean {
    return (value !== undefined && value !== null) ? false : true;
  }
}